import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const DevUserStore = GenericFieldFactory("DEV_USER");